import React, {useState} from 'react'
import { StyledModal, PostPopupTop, StyledBody } from '../PhotoAndPostFlow/styles';
import {AdminCloseIcon} from '../../utils/icons'
import PropTypes from "prop-types";
import {AddUserCard} from './styles'
import {ImageUrl} from '../../utils/constants'
import {CommonButton} from '../common/commonStyles'
import {RadioButton, RadioButtonWrapper } from '../RecogntionAdmin/styles'
import { RemoveManagerFromLocation, Removemanagerfromdepartment} from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
import { fetchApi, getInitials } from '../../utils/methods';
import { NameInitials } from "../Manager/styles";

const RemoveManager = ({showModal, setHideShow, getRemoveData, companyId, getManagerDataByDepartment, type}) => {
  const [selected, seteSelect]=useState(null)

  const handleSelect = (id) => {
    seteSelect(id)
  }

  const onRemoveData = () =>{
    const object ={
      "company_id": companyId,
      [type === 'location' ? 'location_id' : "department_id"]: getRemoveData?.id,
      "manager_id": selected
    }
    removeMember(object)
  }

  const removeMember = async (obj) => {
    
    try {
      const res = await fetchApi(`${type === 'location' ? RemoveManagerFromLocation : Removemanagerfromdepartment}`,"POST", obj);
      if (res?.status === "success") {
        toast.success(res?.data?.message || "Manager added");
        getManagerDataByDepartment(companyId)
        setHideShow(false,null)
      } else {
        toast.error(res?.data?.message || "Something went wrong while fetching users.");
      }
    } catch (error) {
      toast.error(error.message || "An unexpected error occurred.");
    }
  };

  return(
    <>
      <StyledModal show={showModal} width="400px" background="#F8F8F8">
        <PostPopupTop>
          <div className='heading'>{"Remove Manager"}</div>
          <div className='closeIcon' onClick={()=>setHideShow(false,null)}>{AdminCloseIcon()}</div>
        </PostPopupTop>
        <div style={{ height: "1px", width: "100%", background: "#EFEFEF", margin: "0" }} />
        <StyledBody paddingValue="16px 24px">
          <div className='wrap'>
            {getRemoveData?.managers?.map((data,index)=>
              (<AddUserCard key={index}>
                {data.profile_image !== "profile-Image/default.png" ?
                  <div className='image'>
                    <img src={ImageUrl+"/"+data.profile_image}/>
                  </div>:
                  <NameInitials id="name-initials">
                    {getInitials(data?.fname)}{getInitials(data?.lname)}
                  </NameInitials> 
                }
                <div className='name'>{data?.fname}{" "}{data?.lname}</div>
                <div className='checkbox' onClick={() => handleSelect(data?.uid)}>
                  <RadioButtonWrapper>
                    <div className='RadioButtonContainer'>
                      <RadioButton
                        type="radio"
                        checked={selected === data?.uid}
                        handler={handleSelect}
                        id={"1"}
                      />
                    </div>
                  </RadioButtonWrapper>
                </div>
              </AddUserCard>))
            }
          </div>
          <div className='button-wrap' style={{marginTop:"16px"}} >
            <CommonButton disabled={selected ? 0 : 1} onClick={selected?()=>onRemoveData():null}>Remove</CommonButton>
          </div>
        </StyledBody>
      </StyledModal>
    </>
  )
}

RemoveManager.propTypes = {
  showModal: PropTypes.bool,
  setHideShow: PropTypes.func,
  companyId: PropTypes.number,
  getSelectedId: PropTypes.number,
  getRemoveData: PropTypes.object,
  getManagerDataByDepartment: PropTypes.func,
  type:PropTypes.string
};

export default RemoveManager